import { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";

import MainLayout from "layouts/MainLayout";
import QuizQuestion from "pages/QuizQuestion";
import Login from "pages/Login";
import AdminLogin from "pages/AdminLogin";
import AddQuestion from "pages/AddQuestion";
import EditQuestion from "pages/EditQuestion";
import QuestionsList from "pages/QuestionsList";
import UsersList from "pages/UsersList";
import AnswersReport from "pages/AnswersReport";
import About from "pages/About";
import PrivacyPolicy from "pages/PrivacyPolicy";
import Terms from "pages/Terms";
import Contact from "pages/Contact";
import { REACT_APP_BACKEND_URI } from "./config";
import { checkAuth } from "store/auth/authSlice";

axios.defaults.baseURL = REACT_APP_BACKEND_URI;

function App() {
  const { token, authSet } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

  if (!authSet)
    return <div className="flex justify-center items-center">Loading...</div>;

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <Routes>
        {token ? (
          <Route path="/" element={<MainLayout />}>
            <Route index element={<QuizQuestion />} />
            <Route path="add-question" element={<AddQuestion />} />
            <Route path="edit-question/:id" element={<EditQuestion />} />
            <Route path="questions-list" element={<QuestionsList />} />
            <Route path="users-list" element={<UsersList />} />
            <Route path="answers-report" element={<AnswersReport />} />
          </Route>
        ) : (
          <Route path="/" element={<Login />} />
        )}

        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;
